import { ImageDetailsPageTabs } from 'app/plugins/openstack/components/images/details/model'
import { TableHeaderTooltip } from 'app/plugins/openstack/components/images/ImagesListPage'
import { IVolumeSnapshotDetailsPageTabs } from 'app/plugins/openstack/components/storage/snapshots/details/model'
import { StatusCellComponent } from 'app/plugins/openstack/components/storage/snapshots/VolumeSnapshotsListPage'
import SimpleLink from 'core/components/SimpleLink'
import TitleWithInfoIcon from 'core/components/TitleWithInfoIcon'
import { createGridLinkCell } from 'core/elements/grid/cells/GridLinkCell'
import { routeManager } from 'core/utils/routes'
import { IVolumeDetailsPageTabs } from 'openstack/components/storage/volumes/volume-details/model'
import { humanReadableSize } from 'openstack/helpers'
import React from 'react'
import { formatDate } from 'utils/misc'

export const getVolumeSnapshotColumns = ({ volumesById, hideKeys = ['id'] }) => [
  {
    key: 'name',
    label: 'Name',
    CellComponent: createGridLinkCell({
      routeToFn: ({ id, name }) =>
        !!name
          ? routeManager.routes.openstack.volumeSnapshotDetails.path({
              id,
              tab: IVolumeSnapshotDetailsPageTabs.Overview,
            })
          : '',
    }),
    display: hideKeys.includes('name') ? false : true,
  },
  {
    key: 'id',
    label: 'UUID',
    display: hideKeys.includes('id') ? false : true,
  },
  {
    key: 'description',
    label: 'Description',
    display: hideKeys.includes('description') ? false : true,
  },
  {
    key: 'status',
    label: 'Status',
    CellComponent: StatusCellComponent,
    display: hideKeys.includes('status') ? false : true,
  },
  {
    key: 'size',
    label: 'Size',
    render: (size) => humanReadableSize(size * 1024 * 1024 * 1024),
    display: hideKeys.includes('size') ? false : true,
  },
  {
    key: 'volume_id',
    label: 'Source Volume',
    render: (volumeId) => (
      <SimpleLink
        src={routeManager.routes.openstack.volumeDetails.path({
          id: volumeId,
          tab: IVolumeDetailsPageTabs.Overview,
        })}
      >
        {volumesById?.[volumeId]?.name || volumeId}
      </SimpleLink>
    ),
    display: hideKeys.includes('volume_id') ? false : true,
  },
  {
    key: 'attachedVmSnapshot.name',
    label: 'VM Snapshot',
    render: (name, item) => {
      if (!item?.attachedVmSnapshot) {
        return null
      }

      return (
        <SimpleLink
          src={routeManager.routes.openstack.imageDetails.path({
            id: item?.attachedVmSnapshot?.id,
            tab: ImageDetailsPageTabs.Overview,
          })}
        >
          {name}
        </SimpleLink>
      )
    },
    display: hideKeys.includes('attachedVmSnapshot.name') ? false : true,
  },
  {
    key: 'volumeType',
    label: (
      <TitleWithInfoIcon
        titleText="Volume Type"
        tooltipMsg={
          <TableHeaderTooltip message="This information is inherited from the source volume" />
        }
      />
    ),
    render: (_, item) => {
      const volume = volumesById?.[item?.volume_id]
      return volume?.volume_type
    },
    display: hideKeys.includes('volumeType') ? false : true,
  },
  {
    key: 'bootable',
    label: (
      <TitleWithInfoIcon
        titleText="Bootable"
        tooltipMsg={
          <TableHeaderTooltip message="This information is inherited from the source volume" />
        }
      />
    ),
    render: (_, item) => {
      const volume = volumesById?.[item?.volume_id]
      return volume?.bootable
    },
    display: hideKeys.includes('bootable') ? false : true,
  },
  {
    key: 'created_at',
    label: 'Created',
    formatFn: (value) => formatDate(value),
    display: hideKeys.includes('created_at') ? false : true,
  },
]
